var exports = {
  "NQ": "xf0b3b88a--ecf1bf--review",
  "nb": "xf0b3b88a--ecf1bf--review--refused",
  "fe": "xf0b3b88a--ecf1bf--review_view_all",
};

module.exports = exports;
